import { render } from "./PsLabel.vue?vue&type=template&id=44731e1f&ts=true"
import script from "./PsLabel.vue?vue&type=script&lang=ts"
export * from "./PsLabel.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__